import { EncryptStorage } from 'encrypt-storage';

const encryptStorage = new EncryptStorage('secret-key-value', {
  storageType: 'sessionStorage',
});

export default encryptStorage;



// WEBPACK FOOTER //
// ./src/libs/encryptStorage.js